import React from "react";
import styled from "styled-components";
import { colors } from "./colors";
import Spinner from "./Spinner";

const SwitchWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    width: 47px;
    height: 23px;
    background-color: ${(props) => (props.$isActive ? colors[props.$variant][900] : colors.neutral[200])};
    border-radius: 14px;
    padding: 2px;
    box-sizing: border-box;
    cursor: ${(props) => (props.$loading ? "wait" : props.$disabled ? "not-allowed" : "pointer")};
    position: relative;
    transition: background-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
    opacity: ${(props) => (props.$loading || props.$disabled ? 0.6 : 1)};
    flex-shrink: 0;

    &::before {
        content: "";
        position: absolute;
        width: 1px;
        height: 10px;
        background-color: white;
        opacity: ${(props) => (props.$isActive ? 1 : 0)};
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

        top: 50%;
        left: ${(props) => (props.$isActive ? "16px" : "26px")};
        transform: translate(-50%, -50%);
    }

    /* Adding the text labels */
    &::after {
        content: "${(props) => !props.$isActive && "O"}";
        position: absolute;
        top: 50%;
        ${(props) => (props.$isActive ? "left: 10px;" : "right: 10px;")}
        transform: translateY(-50%);
        color: ${colors.neutral[500]};
        font-size: 13px;
    }
`;

const SwitchCircle = styled.div`
    width: 19px;
    height: 19px;
    background-color: ${colors.white};
    border-radius: 50%;
    transition: transform 0.3s ease-in-out;
    transform: ${(props) => (props.isActive ? "translateX(24px)" : "translateX(0)")};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Switch = ({ isActive, setIsActive, onClick, loading, disabled, variant = "primary" }) => {
    const toggleSwitch = () => {
        if (loading || disabled) return; // Prevent toggling while loading or disabled
        if (typeof setIsActive === "function") {
            setIsActive((prev) => !prev);
        }
    };

    return (
        <SwitchWrapper
            $isActive={isActive}
            onClick={onClick ? (loading || disabled ? null : onClick) : toggleSwitch}
            role="button"
            aria-pressed={isActive}
            $loading={loading}
            $disabled={disabled}
            $variant={variant}
        >
            <SwitchCircle isActive={isActive}>{loading && <Spinner size={16} thickness={2} />}</SwitchCircle>
        </SwitchWrapper>
    );
};

export default Switch;
